import * as tslib_1 from "tslib";
import { SearchServiceActionTypes, store } from '../../index';
import { settings } from '../../settings';
import ObjectToGetParameterMapper from '../mapper/ObjectToGetParameterMapper';
var AirportSearchClient = /** @class */ (function () {
    function AirportSearchClient() {
    }
    AirportSearchClient.fetchAndDispatchArrivalAirportsAsync = function (term) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var protocol, apiEndpoint, coreBaseUrl, locale, language, parameters, parameterString, searchResult;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                protocol = store.getState().websiteState.app.location.protocol;
                apiEndpoint = settings.coreApi.endPoints.arrivalAirportSearch;
                coreBaseUrl = settings.coreApi.host + settings.coreApi.prefix;
                locale = 'de_DE';
                language = store.getState().websiteState.app.url.context.language;
                if (language.toLowerCase() === 'fr') {
                    locale = 'fr_FR';
                }
                parameters = {
                    locale: locale,
                    term: term
                };
                parameterString = ObjectToGetParameterMapper.map(parameters);
                searchResult = {
                    type: SearchServiceActionTypes.RECEIVE_AIRPORT_SEARCH_RESPONSE,
                    searchResponse: null
                };
                fetch(protocol + '//' + coreBaseUrl + apiEndpoint + '?' + parameterString, {
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                    .then(function (response) {
                    if (response.status === 200) {
                        response.json().then(function (data) {
                            searchResult.searchResponse = _this.mapToAirportResponse(data);
                            store.dispatch(searchResult);
                        });
                    }
                    else {
                        console.error('Error while fetching products', response.status, response);
                        store.dispatch(searchResult);
                    }
                }).catch(function (error) {
                    console.error('Error while fetching products', error);
                    store.dispatch(searchResult);
                });
                return [2 /*return*/];
            });
        });
    };
    AirportSearchClient.mapToAirportResponse = function (response) {
        var searchResponseItems = this.mapToAirportSearchResponseItems(response);
        var airportSearchServiceResponse = {
            context: {},
            airports: searchResponseItems
        };
        return airportSearchServiceResponse;
    };
    AirportSearchClient.mapToAirportSearchResponseItems = function (response) {
        var items = [];
        if (Array.isArray(response) && response.length > 0) {
            response.forEach(function (airport) {
                var searchResponseItem = {
                    code: airport.code,
                    name: airport.name,
                    countryCode: airport.countryCode,
                    latitude: airport.latitude,
                    longitude: airport.longitude,
                    region: airport.region,
                    city: airport.city,
                    regionId: airport.regionId,
                    cityId: airport.cityId
                };
                items.push(searchResponseItem);
            });
        }
        return items;
    };
    return AirportSearchClient;
}());
export default AirportSearchClient;
